import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';
import { Car, Gauge, TrafficCone, ShieldCheck, Settings, Clock } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const Courses = () => {
  const { t } = useLanguage();
  const coursesText = t(translations.courses);

  const iconMap = {
    car: Car,
    gauge: Gauge,
    'traffic-cone': TrafficCone,
    'shield-check': ShieldCheck,
    settings: Settings,
    clock: Clock,
  };

  return (
    <div className="min-h-screen">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#0B1F3F] to-[#1a3a5f] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{coursesText.title}</h1>
          <p className="text-xl text-gray-200">{coursesText.subtitle}</p>
        </div>
      </section>

      {/* Courses Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {coursesText.list.map((course, index) => {
              const IconComponent = iconMap[course.icon] || Car;
              return (
                <Card key={index} className="hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-[#FF6B35]">
                  <CardHeader>
                    <div className="w-14 h-14 bg-gradient-to-br from-[#FF6B35] to-[#FF8A5B] rounded-lg flex items-center justify-center mb-4 shadow-md">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <CardTitle className="text-xl text-[#0B1F3F]">{course.name}</CardTitle>
                    <CardDescription className="text-[#FF6B35] font-semibold">
                      Duration: {course.duration}
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-700 leading-relaxed">{course.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Courses;
